import React from 'react'
import Icon, { IconName } from '@dustin-web/microsite-components/src/icon'
import Link from 'next/link'
import { CarouselTest } from '@dustin-web/microsite-components/src/carousel-test/carousel'
import { GridBlock } from '../../graphql/generated/graphql-types'

type TileProps = {
  icon: IconName
  label: string
  url: string
}

type TileGridBlock = GridBlock & {
  properties: TileProps
}

type TelesProps = {
  tiles: TileGridBlock[]
}

export const Tile = ({ icon, label, url }: TileProps) => {
  return (
    <div className="u-border u-border-black u-px-12 u-py-12 u-h-100">
      <Icon name={icon} className="i-20" />
      <Link
        draggable="false"
        href={url}
        style={{ userSelect: 'none' }}
        className="d-block u-decoration-none p-sm">
        {label}
      </Link>
    </div>
  )
}

export const TilesBlock = ({ tiles }: TelesProps) => (
  <CarouselTest
    type={'tiles'}
    partialVisible={true}
    infinite={false}
    dots={false}
    list={tiles.map((tile: TileGridBlock, index: number) => (
      <Tile key={`${index}${tile.properties.label}`} {...tile.properties} />
    ))}
    className="tiles"
  />
)
